import { Injectable } from '@angular/core';

import { Auth, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, onAuthStateChanged, User  } from '@angular/fire/auth';
import { Observable } from 'rxjs';

@Injectable()
export class AuthService {
  user: Observable<User | null>;
  emailUser: string = '';

  constructor(private auth: Auth) {
    //this.user = firebaseAuth.authState;
    this.user = new Observable<User | null>(subscriber => {
      return onAuthStateChanged(this.auth, subscriber);
    });
  }

  signup(email: string, password: string) {

      return createUserWithEmailAndPassword(this.auth, email, password)
      .then(value => {
        console.log('Success!', value);
      })
      .catch(err => {
        console.log('Something went wrong:',err.message);
      });
  }

  // login(email: string, password: string) {
  //   this.firebaseAuth
  //     .signInWithEmailAndPassword(email, password)
  //     .then(value => {

  //       this.emailUser = email;
  //       console.log('Nice, it worked!');
  //     })
  //     .catch(err => {
  //       console.log('Something went wrong:',err.message);
  //     });
  // }

  /**
   *
   * @param email
   * @param password
   * @returns Returns a promise
   */

  login(email: string, password: string) {
    return signInWithEmailAndPassword(this.auth, email, password);
  }

  logout() {
    return this.auth.signOut();
  }

  enviarLink(email: string) {
    return sendPasswordResetEmail(this.auth, email);
  }
}
